import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/marketing/Header";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut } from "lucide-react";

export default function PortalHeader({ title }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/dashboard" data-testid="portal-brand-link" className="flex items-center gap-3">
          <Logo />
          {title && <span className="text-slate-400 text-sm hidden sm:inline">/ {title}</span>}
        </Link>
        <div className="flex items-center gap-3">
          {user && (
            <div className="hidden sm:block text-right">
              <div className="text-sm font-medium text-slate-800" data-testid="portal-user-name">
                {user.company_name || user.name}
              </div>
              <div className="text-xs text-slate-500 capitalize">{user.role}</div>
            </div>
          )}
          <Button variant="outline" size="sm" data-testid="logout-btn"
            onClick={async () => { await logout(); nav("/"); }}>
            <LogOut className="h-4 w-4 mr-1" /> Logout
          </Button>
        </div>
      </div>
    </header>
  );
}
